<label class="form-label">{{ label }}</label>
<div class="row">
  <div class="col-auto">
    <app-background #background (change)="onChange()" label="Background"></app-background>
  </div>
  <div class="col-auto">
    <app-color #color (change)="onChange()" label="Color"></app-color>
  </div>
  <div class="col">
    <app-border #border (change)="onChange()" label="Border"></app-border>
  </div>
</div>
